import { Injectable } from '@angular/core';
import {DataTable} from "primeng/primeng";

@Injectable()
export class DatatableExportService {

  constructor() { }

  exportToHtml(datatable: DataTable, title: string = 'Export') {
    let html = `
    <!DOCTYPE html>
<html>
<head>
    <title>${title}</title>
    <style>
        table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
        }

        td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
            white-space: nowrap;
        }

        tr:nth-child(even) {
            background-color: #dddddd;
        }
    </style>
</head>
<body>

<table>
    <tr>`;
    //headers
    datatable.columns.forEach((column) => {
      if (column.exportable && column.field && !column.hidden) {
        html += `<th>${column.header || column.field}</th>`;
      }
    });

    html += `</tr>`;

    datatable.dataToRender.forEach(function (record, i) {
      html += `<tr>`;
      for (let i_1 = 0; i_1 < datatable.columns.length; i_1++) {
        let column = datatable.columns[i_1];
        if (column.exportable && column.field && !column.hidden) {
          let cellData = datatable.resolveFieldData(record, column.field);
          html += `<td>${cellData ? cellData : ''}</td>`;
        }
      }
    });

    html += `
        </table>
      </body>
      </html>`;

    let wnd = window.open('about:blank', '', '_blank');
    wnd.document.write(html);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/services/datatable-export.service.ts